<template>
  <a-card :bordered="false" :class="'cust-erp-sub-tab'">
    <!-- 操作按钮区域 -->
    <div class="table-operator" v-if="mainId">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
      <a-button v-show=false type="primary" icon="download" @click="handleExportXls('合同价格清单详情')">{{$t('button.export')}}</a-button>
      <a-upload v-show=false
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel">
          <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>
      </a-upload>
<!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
      <a-dropdown v-show=false>
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="localHandleEdit(record)">{{$t('button.edit')}}</a>
          <a-divider v-show=false type="vertical" />
          <a-popconfirm v-show=false :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
            <a>{{$t('button.delete')}}</a>
          </a-popconfirm>
        </span>

      </a-table>
    </div>

    <efsMdContractPriceListDetail-modal ref="modalForm" @ok="modalFormOk" :mainId="mainId"></efsMdContractPriceListDetail-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdContractPriceListDetailModal from './modules/EfsMdContractPriceListDetailModal'



  export default {
    name: "EfsMdContractPriceListDetailList",
    mixins:[JeecgListMixin],
    components: { EfsMdContractPriceListDetailModal },
    props:{
      mainId:{
        type:String,
        default:'',
        required:false
      }
    },
    watch:{
      mainId:{
        immediate: true,
        handler(val) {
          if(!this.mainId){
            this.clearList()
          }else{
            this.queryParam['conCode'] = val
            this.loadData(1);
          }
        }
      }
    },
    data () {
      return {
        description: '合同价格清单管理页面',
        disableMixinCreated:true,
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
             slotName: 'tableHeader.materialCommonNameFileNo',
            scopedSlots: { title: 'tableHeader.materialCommonNameFileNo'},
            align:"center",
            dataIndex: 'mmCode',
          },
          {
             slotName: 'tableHeader.materialCategory',
                        scopedSlots: { title: 'tableHeader.materialCategory'},
            align:"center",
            dataIndex: 'mmCategory_dictText',
            // dataIndex: 'mmCategory',
          },
          {
             slotName: 'tableHeader.materialCommonName',
            scopedSlots: { title: 'tableHeader.materialCommonName'},
            align:"center",
            dataIndex: 'mmName'
          },
          {
             slotName: 'tableHeader.specification',
            scopedSlots: { title: 'tableHeader.specification'},
            align:"center",
            dataIndex: 'spec'
          },
          {
             slotName: 'tableHeader.model',
            scopedSlots: { title: 'tableHeader.model'},
            align:"center",
            dataIndex: 'model'
          },
          {
             slotName: 'tableHeader.unitOfMeasurement',
            scopedSlots: { title: 'tableHeader.unitOfMeasurement'},
            align:"center",
            dataIndex: 'unit_dictText',
          },
          {
             slotName: 'tableHeader.unitPrice',
            scopedSlots: { title: 'tableHeader.unitPrice'},
            align:"center",
            dataIndex: 'price'
          },
          {
            slotName: 'tableHeader.version',
            scopedSlots: { title: 'tableHeader.version'},
            align:"center",
            dataIndex: 'version'
          },
          {
             slotName: 'tableHeader.description',
            scopedSlots: { title: 'tableHeader.description'},
            align:"center",
            dataIndex: 'description'
          },
          // {
          //   title:'公司',
          //   align:"center",
          //   dataIndex: 'companyCode'
          // },
          // {
          //   title:'审核状态',
          //   align:"center",
          //   dataIndex: 'approvalStatus'
          // },
          // {
          //   title:'申请人',
          //   align:"center",
          //   dataIndex: 'applicant'
          // },
          // {
          //   title:'申请发起时间',
          //   align:"center",
          //   dataIndex: 'applyTime'
          // },
          // {
          //   title:'最后审批人',
          //   align:"center",
          //   dataIndex: 'lastApprover'
          // },
          // {
          //   title:'最后审批时间',
          //   align:"center",
          //   dataIndex: 'lastApproveTime',
          //   customRender:function (text) {
          //     return !text?"":(text.length>10?text.substr(0,10):text)
          //   }
          // },
          // {
          //   title:'是否有效',
          //   align:"center",
          //   dataIndex: 'validFlag'
          // },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/contractPriceList/efsMdContractPriceList/listEfsMdContractPriceListDetailByMainId",
          delete: "/contractPriceList/efsMdContractPriceList/deleteEfsMdContractPriceListDetail",
          deleteBatch: "/contractPriceList/efsMdContractPriceList/deleteBatchEfsMdContractPriceListDetail",
          exportXlsUrl: "/contractPriceList/efsMdContractPriceList/exportEfsMdContractPriceListDetail",
          importUrl: "/contractPriceList/efsMdContractPriceList/importEfsMdContractPriceListDetail",
        },
        dictOptions:{
         validFlag:[],
        },

      }
    },
    computed: {
      importExcelUrl(){
        return `${window._CONFIG['domianURL']}/${this.url.importUrl}/${this.mainId}`;
      }
    },
    methods: {
      clearList(){
        this.dataSource=[]
        this.selectedRowKeys=[]
        this.ipagination.current = 1
      },
      localHandleEdit(record){
        this.$refs.modalForm.isMmCodeDisabled = true;
        this.handleEdit(record);
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>
